import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {CountriesService} from '../../../services/countries.service';
import {MatDialogRef} from '@angular/material/dialog';
import {Countries} from '../../../models/countries.interface';

@Component({
  selector: 'app-create-country',
  templateUrl: './create-country.component.html',
  styleUrls: ['./create-country.component.scss']
})
export class CreateCountryComponent implements OnInit {

  regions = [
    {value: 'EU', name: 'EUROPE'},
    {value: 'AFRICA', name: 'AFRICA'},
    {value: 'ASIA', name: 'ASIA'},
    {value: 'NORTH_AMERICA', name: 'NORTH AMERICA'},
    {value: 'LATIN_AMERICA', name: 'LATIN AMERICA'},
    {value: 'OCEANIA', name: 'OCEANIA'},
  ];

  countryCreateForm = this.formBuilder.group({
    code: ['', Validators.required],
    name: ['', Validators.required],
    region: ['', Validators.required],
  });

  get codeControl(): FormControl {
    return this.countryCreateForm.get('code') as FormControl;
  }
  get nameControl(): FormControl {
    return this.countryCreateForm.get('name') as FormControl;
  }
  get regionControl(): FormControl {
    return this.countryCreateForm.get('region') as FormControl;
  }

  @Output()
  createEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(private dialogRef: MatDialogRef<CreateCountryComponent>,
              private readonly formBuilder: FormBuilder,
              private readonly countriesService: CountriesService) { }

  ngOnInit(): void {
  }

  sendCreationRequest(): void {
    const dto: Countries | null = this.getCreationDto();
    if (dto) {
      this.countriesService.createCountry(dto).subscribe(
        () => {
          this.createEvent.emit();
          this.closeDialog();
        },
        () => {
          this.closeDialog();
        }
      );
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private getCreationDto(): Countries {
    return {
      code: this.codeControl.value,
      name: this.nameControl.value,
      region: this.regionControl.value,
      isEUMember: this.regionControl.value === 'EU'
    };
  }

}
